/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M2 19H8M8 19L6 17M8 19L6 21M15 12H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 15.2857V9.4C2 7.15979 2 6.03968 2.43597 5.18404C2.81947 4.43139 3.43139 3.81947 4.18404 3.43597C5.03968 3 6.15979 3 8.4 3H15.6C17.8402 3 18.9603 3 19.816 3.43597C20.5686 3.81947 21.1805 4.43139 21.564 5.18404C22 6.03968 22 7.15979 22 9.4V14.6C22 16.8402 22 17.9603 21.564 18.816C21.1805 19.5686 20.5686 20.1805 19.816 20.564C18.9603 21 17.8402 21 15.6 21H11M2.5 8H21.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 8H22V14.6C22 16.8402 22 17.9603 21.564 18.816C21.1805 19.5686 20.5686 20.1805 19.816 20.564C18.9603 21 17.8402 21 15.6 21H8.4C6.15979 21 5.03969 21 4.18404 20.564C3.43139 20.1805 2.81947 19.5686 2.43597 18.816C2 17.9603 2 16.8402 2 14.6V8Z"
				fill="currentColor"
			/>
			<path
				d="M2 15.2857V9.4C2 7.15979 2 6.03968 2.43597 5.18404C2.81947 4.43139 3.43139 3.81947 4.18404 3.43597C5.03968 3 6.15979 3 8.4 3H15.6C17.8402 3 18.9603 3 19.816 3.43597C20.5686 3.81947 21.1805 4.43139 21.564 5.18404C22 6.03968 22 7.15979 22 9.4V14.6C22 16.8402 22 17.9603 21.564 18.816C21.1805 19.5686 20.5686 20.1805 19.816 20.564C18.9603 21 17.8402 21 15.6 21H11M2 19H8M8 19L6 17M8 19L6 21M2.5 8H21.5M15 12H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M8.367 2.25H15.633C16.7251 2.24999 17.5906 2.24999 18.2883 2.30699C19.0017 2.36527 19.6053 2.48688 20.1565 2.76772C21.0502 3.22312 21.7769 3.94978 22.2323 4.84354C22.5131 5.39472 22.6347 5.99834 22.693 6.71173C22.75 7.40935 22.75 8.27484 22.75 9.36698V14.633C22.75 15.7252 22.75 16.5906 22.693 17.2883C22.6347 18.0017 22.5131 18.6053 22.2323 19.1565C21.7769 20.0502 21.0502 20.7769 20.1565 21.2323C19.6053 21.5131 19.0017 21.6347 18.2883 21.693C17.5906 21.75 16.7252 21.75 15.633 21.75H11C10.5858 21.75 10.25 21.4142 10.25 21C10.25 20.5858 10.5858 20.25 11 20.25H15.6C16.7325 20.25 17.5367 20.2494 18.1661 20.198C18.7867 20.1473 19.171 20.0509 19.4755 19.8958C20.087 19.5842 20.5842 19.087 20.8958 18.4755C21.0509 18.171 21.1473 17.7867 21.198 17.1661C21.2494 16.5367 21.25 15.7325 21.25 14.6L21.25 9.3163C21.25 8.77868 21.25 8.50988 21.141 8.29598C21.0464 8.1104 20.8895 7.95354 20.7039 7.85899C20.49 7.75 20.2179 7.75 19.6736 7.75H4.32642C3.78211 7.75 3.50996 7.75 3.29606 7.85899C3.11047 7.95354 2.95361 8.1104 2.85904 8.29598C2.75005 8.50988 2.75003 8.77868 2.75 9.3163L2.75 15.2857C2.75 15.6999 2.41421 16.0357 2 16.0357C1.58579 16.0357 1.25 15.6999 1.25 15.2857V9.367C1.24999 8.27485 1.24999 7.40936 1.30699 6.71173C1.36527 5.99834 1.48688 5.39472 1.76772 4.84354C2.22312 3.94978 2.94978 3.22312 3.84354 2.76772C4.39472 2.48688 4.99834 2.36527 5.71173 2.30699C6.40936 2.24999 7.27486 2.24999 8.367 2.25Z"
				fill="currentColor"
			/>
			<path
				d="M5.46967 16.4697C5.76256 16.1768 6.23744 16.1768 6.53033 16.4697L8.53033 18.4697C8.82322 18.7626 8.82322 19.2374 8.53033 19.5303L6.53033 21.5303C6.23744 21.8232 5.76256 21.8232 5.46967 21.5303C5.17678 21.2374 5.17678 20.7626 5.46967 20.4697L6.18934 19.75H2C1.58579 19.75 1.25 19.4142 1.25 19C1.25 18.5858 1.58579 18.25 2 18.25H6.18934L5.46967 17.5303C5.17678 17.2374 5.17678 16.7626 5.46967 16.4697Z"
				fill="currentColor"
			/>
			<path
				d="M15 11.25C14.5858 11.25 14.25 11.5858 14.25 12C14.25 12.4142 14.5858 12.75 15 12.75H18C18.4142 12.75 18.75 12.4142 18.75 12C18.75 11.5858 18.4142 11.25 18 11.25H15Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 15.2857V9.4C2 7.15979 2 6.03968 2.43597 5.18404C2.81947 4.43139 3.43139 3.81947 4.18404 3.43597C5.03968 3 6.15979 3 8.4 3H9.5H10M11 21H15.6C17.8402 21 18.9603 21 19.816 20.564C20.5686 20.1805 21.1805 19.5686 21.564 18.816C22 17.9603 22 16.8402 22 14.6V9.4C22 7.15979 22 6.03968 21.564 5.18404C21.1805 4.43139 20.5686 3.81947 19.816 3.43597C18.9603 3 17.8402 3 15.6 3H14.5H14M2 19H8M8 19L6 17M8 19L6 21M6 8H21.5M15 12H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 15.2857V9.4C2 7.15979 2 6.03968 2.43597 5.18404C2.81947 4.43139 3.43139 3.81947 4.18404 3.43597C5.03968 3 6.15979 3 8.4 3H15.6C17.8402 3 18.9603 3 19.816 3.43597C20.5686 3.81947 21.1805 4.43139 21.564 5.18404C22 6.03968 22 7.15979 22 9.4V14.6C22 16.8402 22 17.9603 21.564 18.816C21.1805 19.5686 20.5686 20.1805 19.816 20.564C18.9603 21 17.8402 21 15.6 21H11M2 19H8M8 19L6 17M8 19L6 21M2.5 8H21.5M15 12H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M8.367 2.25H15.633C16.7251 2.24999 17.5906 2.24999 18.2883 2.30699C19.0017 2.36527 19.6053 2.48688 20.1565 2.76772C21.0502 3.22312 21.7769 3.94978 22.2323 4.84354C22.5131 5.39472 22.6347 5.99834 22.693 6.71173C22.75 7.40935 22.75 8.27484 22.75 9.36698V14.633C22.75 15.7252 22.75 16.5906 22.693 17.2883C22.6347 18.0017 22.5131 18.6053 22.2323 19.1565C21.7769 20.0502 21.0502 20.7769 20.1565 21.2323C19.6053 21.5131 19.0017 21.6347 18.2883 21.693C17.5906 21.75 16.7252 21.75 15.633 21.75H11C10.5858 21.75 10.25 21.4142 10.25 21C10.25 20.5858 10.5858 20.25 11 20.25H15.6C16.7325 20.25 17.5367 20.2494 18.1661 20.198C18.7867 20.1473 19.171 20.0509 19.4755 19.8958C20.087 19.5842 20.5842 19.087 20.8958 18.4755C21.0509 18.171 21.1473 17.7867 21.198 17.1661C21.2494 16.5367 21.25 15.7325 21.25 14.6L21.25 9.3163C21.25 8.77868 21.25 8.50988 21.141 8.29598C21.0464 8.1104 20.8895 7.95354 20.7039 7.85899C20.49 7.75 20.2179 7.75 19.6736 7.75H4.32642C3.78211 7.75 3.50996 7.75 3.29606 7.85899C3.11047 7.95354 2.95361 8.1104 2.85904 8.29598C2.75005 8.50988 2.75003 8.77868 2.75 9.3163L2.75 15.2857C2.75 15.6999 2.41421 16.0357 2 16.0357C1.58579 16.0357 1.25 15.6999 1.25 15.2857V9.367C1.24999 8.27485 1.24999 7.40936 1.30699 6.71173C1.36527 5.99834 1.48688 5.39472 1.76772 4.84354C2.22312 3.94978 2.94978 3.22312 3.84354 2.76772C4.39472 2.48688 4.99834 2.36527 5.71173 2.30699C6.40936 2.24999 7.27486 2.24999 8.367 2.25Z"
				fill="currentColor"
			/>
			<path
				d="M5.46967 16.4697C5.76256 16.1768 6.23744 16.1768 6.53033 16.4697L8.53033 18.4697C8.82322 18.7626 8.82322 19.2374 8.53033 19.5303L6.53033 21.5303C6.23744 21.8232 5.76256 21.8232 5.46967 21.5303C5.17678 21.2374 5.17678 20.7626 5.46967 20.4697L6.18934 19.75H2C1.58579 19.75 1.25 19.4142 1.25 19C1.25 18.5858 1.58579 18.25 2 18.25H6.18934L5.46967 17.5303C5.17678 17.2374 5.17678 16.7626 5.46967 16.4697Z"
				fill="currentColor"
			/>
			<path
				d="M15 11.25C14.5858 11.25 14.25 11.5858 14.25 12C14.25 12.4142 14.5858 12.75 15 12.75H18C18.4142 12.75 18.75 12.4142 18.75 12C18.75 11.5858 18.4142 11.25 18 11.25H15Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
